import {
  DefaultPaginationLimit,
  DefaultPaginationLimitOptions
} from "../../consts";
import { genOption, getOption, getOptionWithDefault } from "./helpers";
import { Option } from "./types";

if (!DefaultPaginationLimitOptions.includes(DefaultPaginationLimit)) {
  throw new Error(
    `DefaultPageSize (${DefaultPaginationLimit}) ` +
      "is missing from DefaultPageSizeOptions " +
      `([${DefaultPaginationLimitOptions.join(", ")}])`
  );
}

export const limitOptions = DefaultPaginationLimitOptions.map(genOption());

export const getLimitOption = (value: number): Option<number> | null =>
  getOption<number>(limitOptions, value);

export const getLimitOptionWithDefault = getOptionWithDefault<number>(
  limitOptions,
  getLimitOption(DefaultPaginationLimit)
);
